<script>
import financiadorService from "@/services/financiador";

export default {
  name: "FinanciadorSelect",
  props: {
    value: { type: String, default: "" },
    isDisabled: { type: Boolean, default: false },
    // Nombre de obra social ya cargado en el paciente (medicalInsuranceObj.publicInsurance.name).
    // Si coincide con un nombreOrigen de la lista, se usa solo para precargar el valor inicial.
    patientInsuranceName: { type: String, default: "" },
  },
  data() {
    return {
      financiadores: [],
      isLoading: false,
    };
  },
  created() {
    this.getFinanciadores();
  },
  methods: {
    async getFinanciadores() {
      this.isLoading = true;
      try {
        this.financiadores = await financiadorService.get();
      } catch (err) {
        console.error("Error fetching financiadores:", err);
      }
      this.isLoading = false;

      if (
        !this.value &&
        this.patientInsuranceName &&
        this.financiadores.includes(this.patientInsuranceName)
      ) {
        this.$emit("input", this.patientInsuranceName);
      }
    },
    onInput(value) {
      this.$emit("input", value || "");
    },
  },
};
</script>

<template lang="pug">
el-select(
  :value="value"
  @input="onInput"
  filterable
  clearable
  :loading="isLoading"
  :disabled="isDisabled"
  placeholder="Ingrese una obra social"
)
  el-option(
    v-for="financiador in financiadores"
    :key="financiador"
    :label="financiador"
    :value="financiador"
  )
</template>
